<template>
  <div v-if="show">
    <div class="tw-controls-wrapper z-top controls-background">
      <div>
        <div class="card-header bg-white d-flex justify-content-between align-items-center  pl-3 pr-2">
          <div class="card-title mb-0 d-flex align-items-center">
            <span class="font-weight-bold">{{ $t("controls.title") }} </span>
          </div>
          <div class="card-title mb-0 d-flex align-items-end">
            <q-icon name="chevron_right" size="20px" @click="toggleShowControls" />
          </div>
        </div>
        <div class="row card-body  pl-3 pr-3">
          <div
            class="col-lg-12 col-md-12 col-sm-12 form-control controls-border-error bg-red-2 border-danger border-dashed p-2 mb-2"
            v-for="(item, index) in errors" :key="index">
            <span class="text-red-10 font-size-12"> <span class="font-medium"> ({{ item.control }})</span>
              {{ $t(`controls.${item.message}`) }}</span>
          </div>
          <div
            class="col-lg-12 col-md-12 col-sm-12 form-control controls-border-warn bg-amber-1 border-warning border-dashed p-2 mb-2"
            v-for="(item, index) in warnings" :key="index">
            <span class="text-yellow-10 font-size-12">{{ $t(`controls.${item.message}`) }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import store from "@/store";
import i18n from "../../i18n";

@Options({})
export default class ControlsDialog extends Vue {

  get show() {
    return store.state.controlsModule.show
  }

  get errors() {
    return store.state.controlsModule.errors
  }

  get warnings() {
    return store.state.controlsModule.warnings
  }

  toggleShowControls() {
    return store.dispatch('controlsModule/toggleShow')
  }


}
</script>

<style scoped>
.controls-background {
  background-color: white;
  border-radius: 10px;
  -webkit-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
}

.controls-border-error {
  border-radius: 10px;
  border: 3px dashed #F1416C;
}

.controls-border-warn {
  border-radius: 10px;
  border: 3px dashed #FFA800;
}
</style>
